export const formatCAD = new Intl.NumberFormat('en-CA', {
  style: 'currency',
  currency: 'CAD'
});
